import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Container } from 'reactstrap';
import './footer.scss';
import { FaWhatsapp } from 'react-icons/fa'
const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const footerRef = useRef(null);

    useEffect(() => {
        const currentFooter = footerRef.current;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            {
                threshold: 0.1,
                rootMargin: '0px'
            }
        );

        if (currentFooter) {
            observer.observe(currentFooter);
        }

        return () => {
            if (currentFooter) {
                observer.unobserve(currentFooter);
            }
        };
    }, []);

    return (
        <footer
            ref={footerRef}
            className={`dark-gray-footer ${isVisible ? 'footer-visible' : ''}`}
        >
            {/* animatedd gradient line at top */}
            <div className="footer-gradient-line"></div>

            <div className="footer-top-section">
                <Container>
                    <Row className="">
                        <Col lg={4} md={12} sm={12} className="mb-4 mb-lg-0 footer-col">
                            <div className="footer-col-content company-col">
                                <h5 className="footer-heading accent-text mb-4">
                                    <span className="heading-icon">✦</span>
                                    Quantumcrest Solutions Ltd
                                </h5>
                                <div className="company-info">
                                    <p className="company-details mb-0">
                                        <span className="detail-line">QUANTUMCREST SOLUTIONS LTD</span>
                                        <span className="detail-line">(trading as Reachtix)</span>
                                        <span className="detail-line">Registered in England and Wales.</span>
                                        <span className="detail-line">Company number: 16088299</span>
                                        <span className="detail-line">Registered office: 400 Thames Valley Park Drive, Reading, RG6 1PT</span>
                                    </p>
                                </div>
                                <div className="company-badge">
                                    <span className="badge-text">D-U-N-S©: 232675067</span>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4} md={12} sm={12} className="mb-4 mb-lg-0 footer-col">
                            <div className="footer-col-content contact-col">
                                <h5 className="footer-heading accent-text mb-4">
                                    <span className="heading-icon">📞</span>
                                    Quick Contact
                                </h5>
                                <ul className="contact-list list-unstyled">
                                    <li className="mb-3 contact-item">
                                        <div className="contact-icon-wrapper">
                                            <i className="fa fa-envelope accent-icon"></i>
                                            <span className="icon-glow"></span>
                                        </div>
                                        <a href="mailto:info@reachtix.com" className="contact-link">
                                            info@reachtix.com
                                        </a>
                                    </li>
                                    <li className="mb-3 contact-item">
                                        <div className="contact-icon-wrapper">
                                            <i className="fa fa-clock accent-icon"></i>
                                            <span className="icon-glow"></span>
                                        </div>
                                        <p className="mb-0 contact-text">Mon-Fri: 9.00 AM – 5.00 PM</p>
                                    </li>
                                    <li className="mb-3 contact-item">
                                        <div className="contact-icon-wrapper">
                                            <i className="fa fa-phone accent-icon"></i>
                                            <span className="icon-glow"></span>
                                        </div>
                                        <a href="tel:447943048610" className="contact-link">
                                            +44 118 228 7381
                                        </a>
                                    </li>
                                </ul>


                            </div>
                        </Col>

                        <Col lg={4} md={12} sm={12} className="mb-4 mb-lg-0 footer-col">
                            <div className="footer-col-content card-col">
                                <h5 className="footer-heading accent-text mb-4">
                                    <span className="heading-icon"></span>
                                    Connect With Us
                                </h5>
                                {/* Social Media Links */}
                                <div className="social-links-mini">
                                    <a href="https://www.linkedin.com/company/reachtix" className="social-icon-link" aria-label="LinkedIn">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                    <a href="https://x.com/reachtix?s=11" className="social-icon-link" aria-label="Twitter">
                                        <i className="fab fa-x-twitter"></i>
                                    </a>
                                    <a href="https://www.facebook.com/share/1RGkqHo5EV/?mibextid=wwXIfr" className="social-icon-link" aria-label="Facebook">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                    <a href="https://www.instagram.com/reachtix_agency?igsh=MTd6ankybDg0NnhjZw%3D%3D&utm_source=qr" className="social-icon-link" aria-label="Instagram">
                                        <i className="fab fa-instagram"></i>
                                    </a>
                                    <a href="https://t.me/@reachtix" className="social-icon-link" aria-label="telegram">
                                        <i className="fab fa-telegram"></i>
                                    </a>
                                    <a href="https://youtube.com/@reachtix" className="social-icon-link" aria-label="youtube">
                                        <i className="fab fa-youtube"></i>
                                    </a>
                                    <a href="https://wa.me/447943048610" className="social-icon-link" aria-label="whatsapp">
                                        <i><FaWhatsapp className='svgicon' /></i>
                                    </a>
                                </div>
                                <p className="card-caption mt-3">Scan to connect • Tap to interact</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="footer-bottom-section">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6} className="mb-3 mb-md-0">
                            <div className="copyright-section">
                                <p className="mb-0 copyright-text">
                                    <span className="copyright-symbol">©</span>
                                    <span className="copyright-year">2025</span>
                                    <a
                                        href="https://reachtix.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="copyright-link"
                                    >
                                        QUANTUMCREST SOLUTIONS LTD.
                                    </a>
                                    <span className="copyright-rights">All rights reserved.</span>
                                </p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="footer-links">
                                <ul className="list-unstyled d-flex flex-wrap justify-content-md-end gap-3 mb-0">
                                    <li><Link to="/" className="footer-link">Home</Link></li>
                                    <li><Link to="/about" className="footer-link">About</Link></li>
                                    <li><Link to="/services" className="footer-link">Services</Link></li>
                                    <li><Link to="/contact-form" className="footer-link">Contact</Link></li>
                                    <li><Link to="/reachtix-privacy-policy" className="footer-link">Privacy</Link></li>
                                    <li><Link to="/terms" className="footer-link">Terms</Link></li>
                                    <li><Link to="/faq" className="footer-link">FAQ</Link></li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Back to top button */}
            <button
                className="back-to-top"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                aria-label="Back to top"
            >
                <i className="fa fa-chevron-up"></i>
            </button>
        </footer>
    );
};

export default Footer;